import { render, staticRenderFns } from "./Service37Table.vue?vue&type=template&id=c95824a0&"
import script from "./Service37Table.vue?vue&type=script&lang=js&"
export * from "./Service37Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports